module.exports = __webpack_public_path__ + "static/img/visualization-mobile.9908846.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/visualization-mobile.svg
// module id = B0tX
// module chunks = 1